import axios from "axios";
import { BaseUrl } from "./api";
import {
    START_FETCH_PLACE_OF_SUPPLY,
    SUCCESS_FETCH_PLACE_OF_SUPPLY,
    FAILED_FETCH_PLACE_OF_SUPPLY,
} from "./types";

export const fetchPlaceOfSupplyList = (token) => {
    return async (dispatch) => {
        dispatch({
            type: START_FETCH_PLACE_OF_SUPPLY,
        });
        try {
            const res = await axios.get(`${BaseUrl}/place_of_supply`, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    dataType: "json",
                    Authorization: `Bearer ${token}`,
                },
            });
            if (res.statusText == "OK") {
                dispatch({
                    type: SUCCESS_FETCH_PLACE_OF_SUPPLY,
                    payload: res.data,
                });
            } else {
                dispatch({
                    type: FAILED_FETCH_PLACE_OF_SUPPLY,
                    payload: res.data.message,
                });
            }
        } catch (error) {
            dispatch({
                type: FAILED_FETCH_PLACE_OF_SUPPLY,
                payload: error.message,
            });
        }
    };
};
